import { ContactType } from '../../core/constants';
import { Merchant } from '../merchant/merchant';
import { Person } from '../person/person';
import { StreetAddress } from '../streetAddress/streetAddress';
import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';
import { User } from '../users/user';
import { AssignedUser } from '../users/assignedUser';

export class Account {
  id: string;
  accountName: string;

  // TODO: remove these
  owner: Partial<Person> | undefined;
  primaryUser: Partial<User> | undefined;

  billingAddress: Partial<StreetAddress> = StreetAddress.createEmpty();
  billingName: string;
  billingAccountNum: string | undefined;
  billingRoutingNum: string | undefined;
  billingAccountHolderType: string | undefined;
  billingAccountType: string | undefined;
  locations: Merchant[] | undefined;
  contacts: AssignedUser[] = [];

  constructor(account: Partial<Account>) {
    if (account.id == null) {
      throw new Error(
        `Invalid account in constructor: ${JSON.stringify(account)}\n id cannot be null`,
      );
    }
    if (account.accountName == null) {
      throw new Error(
        `Invalid account in constructor: ${JSON.stringify(account)}\n accountName cannot be null`,
      );
    }
    if (account.billingAddress == null) {
      throw new Error(
        `Invalid account in constructor: ${JSON.stringify(account)}\n billing address cannot be null`,
      );
    }
    if (account.billingName == null) {
      throw new Error(
        `Invalid account in constructor: ${JSON.stringify(account)}\n billing name cannot be null`,
      );
    }

    if (account.contacts) {
      this.contacts = account.contacts;
    } else {
      this.contacts = [];
    }

    this.id = account.id;
    this.accountName = account.accountName;
    this.owner = account.owner;
    this.billingAddress = account.billingAddress;
    this.billingName = account.billingName;
    this.billingAccountNum = account.billingAccountNum;
    this.billingRoutingNum = account.billingRoutingNum;
    this.billingAccountHolderType = account.billingAccountHolderType;
    this.billingAccountType = account.billingAccountType;
    this.locations = account.locations;

    if (account.primaryUser) {
      this.primaryUser = new User(account.primaryUser);
    }
  }

  static createEmpty(): Partial<Account> {
    return {
      id: '',
      accountName: '',
      owner: Person.createEmpty(),
      primaryUser: User.createEmpty(),
      billingName: '',
      billingAddress: StreetAddress.createEmpty(),
      billingAccountNum: '',
      billingRoutingNum: '',
      billingAccountHolderType: '',
      billingAccountType: '',
      locations: [],
      contacts: [],
    };
  }

  getContactByType(type: ContactType): AssignedUser | null {
    for (let i = 0; i < this.contacts.length; i++) {
      if (this.contacts[i].contactTypes.includes(type)) {
        return this.contacts[i];
      }
    }
    return null;
  }

  public get primaryContact(): AssignedUser | undefined {
    for (let i = 0; i < this.contacts.length; i++) {
      if (this.contacts[i].contactTypes.includes(ContactType.Primary)) {
        return this.contacts[i];
      }
    }
    return undefined;
  }

  getLocationsAsList(): ListItem[] {
    let items: ListItem[] = [];

    if (this.locations) {
      for (var i = 0; i < this.locations?.length; i++) {
        let l = new ListItem({
          id: this.locations[i].id,
          name: this.locations[i].DBA,
        });
        items.push(l);
      }
    }

    return items;
  }

  static GetLocationsAsList(b: Account): ListItem[] {
    let items: ListItem[] = [];

    if (b.locations) {
      for (var i = 0; i < b.locations?.length; i++) {
        let l = new ListItem({
          id: b.locations[i].id,
          name: b.locations[i].DBA,
        });
        items.push(l);
      }
    }

    return items;
  }
}
